"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.atMentionEncoded = void 0;
exports.atMentionEncoded = /\B@[a-zA-ZÀ-ž0-9_\.]+\|=/g;
